import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ShareBox from './shareBox';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Header extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
        interact: PropTypes.object,
    };
    /**
     * 渲染网页布局
     */
    render() {
        const { docData, interact } = this.props;
        const { columnData } = docData;
        const { title, logo, url } = columnData;
        // 列表信息

        return (
            <div className={styles.LivingTitleBox}>
                <div className={styles.LivingTitleCon}>
                    <div className={styles.fl}>
                        <a href={url} target="_blank" className={styles.logo}>
                            <img src={logo} alt={title} title={title} />
                        </a>
                    </div>
                    <div className={styles.fr}>
                        <ShareBox docData={docData} interact={interact} />
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
